import { computed, inject, type Ref } from 'vue';

import type { NormalizedPerpsPosition } from '@exchange/libs/account/service/src/lib/wss-account-messages';
import type { BookTickProvider } from '@exchange/libs/book-ticker/service/src';
import { marketService } from '@exchange/libs/market/service/src';

const usePositionComputed = (position: Ref<NormalizedPerpsPosition>, maxLeverage: Ref<number | undefined> | undefined) => {
  const { getMarket } = marketService;
  const market = computed(() => getMarket(position.value.instrument_code));
  const marketId = computed(() => position.value.instrument_code);

  const bookTickProvider = inject<BookTickProvider>('bookTickProvider');
  const bookTick = computed(() => bookTickProvider?.getBookTickForMarketId(marketId.value)?.value);
  const bookMidPrice = computed(() => bookTick?.value?.midPrice);

  const unrealizedPnL = computed(() => {
    if (!bookMidPrice.value) return 0;

    const positionSize = Number(position.value.open_volume);
    const positionPrice = position.value.mark_price ? Number(position.value.mark_price) : Number(position.value.average_entry_price);
    const priceDiff = bookMidPrice.value - positionPrice;

    return position.value.direction === 'LONG' ? positionSize * priceDiff : positionSize * -priceDiff;
  });

  const marginUsed = computed(() => {
    if (!maxLeverage?.value) return undefined;

    const positionValue = Number(position.value.open_position);

    return positionValue / maxLeverage.value;
  });

  return {
    marginUsed,
    market,
    unrealizedPnL,
  };
};

export default usePositionComputed;
